import { CardSwapBanner as HomepageDumbCardSwapBanner } from '@sorare/us-sports/src/components/homepage/promo/CardSwapBanner';

import { CardSwapBanner } from 'components/cardswap/Banner';

export const HomepageCardSwapBanner = () => {
  return <CardSwapBanner Banner={HomepageDumbCardSwapBanner} />;
};
